<template>
    <div class="dinero-animation" :style="dinerosStyle" >
        <div class="dinero" ></div>
    </div>
</template>

<script>
import utils from '../../utils/utils.js';
export default {
    props: {
        dinerox: Number,
        dineroy: Number,
        dineroSize: Number,
        dineroScale: Number
    },
    data() {
        return {
            cur: 0
        }
    },
    computed: {
        scale() { return this.dineroScale || (this.dineroSize / 101) || 1 },
        dinerosStyle() { return `left: ${this.dinerox}px;top: ${this.dineroy}px;transform: translate(-50%, -50%) scale(${this.scale});-webkit-transform: translate(-50%, -50%) scale(${this.scale});` }
    }
}
</script>

<style lang="scss" >
@import "../../assets/css/variables.scss";
.dinero-animation {
    position: absolute;
    width: 101px;
    height: 101px;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);

    .dinero {
        height: 100%;
        background-image: url($assetRoot + "/dinero_animation.png");
        animation: dinero_animation step-end .3s infinite;
    }

    @-webkit-keyframes dinero_animation {
        0% { background-position: 0 0; }
        25% { background-position: -101px 0; }
        50% { background-position: -202px 0; }
        75% { background-position: -303px 0; }
    }

    @keyframes dinero_animation {
        0% { background-position: 0 0; }
        25% { background-position: -101px 0; }
        50% { background-position: -202px 0; }
        75% { background-position: -303px 0; }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/animations/RotateDinero.vue